import Image from "next/image";
import React, { CSSProperties } from "react";
import { container_classname, sub_section_heading } from "./constants";
import { isJSXElement } from "@utils/common";

interface SpotlightSectionProps {
    removeHeader?: boolean;
    data?: spotlightContent[];
    textClassName?: string;
    headerText?: string | JSX.Element;
    description?: string;
    sectionStyle?: CSSProperties;
    imageWidth?: number;
    imageHeight?: number;
    cardsStyle?: CSSProperties;
}
interface spotlightContent {
    image?: {
        source: string;
        alt: string;
    };
    icon?: React.ElementType;
    description: string;
    title?: string;
}

const defaultSpotlightContent: spotlightContent[] = [
    {
        description: "Prospects are spread across channels, making outreach fragmented and ineffective.",
        image: {
            source: "https://assets.gallabox.com/gb-home/new-landing/spotlight/broken-chain.svg",
            alt: "broken-chain",
        },
    },
    {
        description: "Sales reps lose valuable time on repetitive lead nurturing instead of closing deals.",
        image: {
            source: "https://assets.gallabox.com/gb-home/new-landing/spotlight/sand-timer.svg",
            alt: "sand-timer",
        },
    },
    {
        description: "Since time is of the essence, leads end up becoming cold and revenue opportunities disappear into the void.",
        image: {
            source: "https://assets.gallabox.com/gb-home/new-landing/spotlight/profit.png",
            alt: "profit",
        },
    },
];

const SpotlightSection: React.FC<SpotlightSectionProps> = ({
    removeHeader,
    data = defaultSpotlightContent,
    textClassName,
    headerText,
    sectionStyle,
    description,
    imageWidth,
    imageHeight,
    cardsStyle,
}) => {
    return (
        <section className="lg:py-20 py-14 font-inter" style={{ backgroundColor: "#E6EEFF", ...sectionStyle }}>
            <div className={`${container_classname} flex flex-col gap-12`}>
                {!removeHeader && isJSXElement(headerText) ? (
                    headerText
                ) : (
                    <h2 className={`${sub_section_heading} text-6xl lg:max-w-7xl`} style={{ fontFamily: "Degular Display" }}>
                        {headerText ?? "Your sales team is drowning in repetitive tasks across channels while deals slip through the cracks"}
                    </h2>
                )}
                {description && <p className="text-xl font-normal max-w-5xl">{description}</p>}
                <div className="flex flex-col lg:flex-row gap-5">
                    {data.map((content, index) => {
                        return (
                            <div className="lg:w-1/3 w-full bg-white rounded-lg p-6 flex flex-col gap-6 items-start" key={`spotlight-section-${index}`} style={cardsStyle}>
                                {content?.icon && (
                                    <div className="bg-white rounded-lg p-3">
                                        <content.icon size={26} style={{ color: "rgba(51, 100, 250, 1)" }} />
                                    </div>
                                )}
                                {content.image && <Image width={imageWidth ?? 84} height={imageHeight ?? 84} src={content.image.source} alt={content.image.alt} />}
                                {content?.title && <p className="text-2xl font-semibold">{content.title}</p>}
                                <p className={`${textClassName ?? "text-xl font-normal"}`}>{content.description}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SpotlightSection;
